import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
//import { CookieService } from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie';


@Injectable({
  providedIn: 'root'
})
export class CookieServiceService {

  constructor(private router: Router,
    private cookieService: CookieService,) { }

  public setJWTCookie(cookieValue: string) {

    this.cookieService.put('app-token',cookieValue,{sameSite:'lax',secure:true});
   // this.cookieService.set('app-token', cookieValue, { sameSite: 'None', path: "/", secure: true });     
  }

  public getJWTToken() {
    return this.cookieService.get("app-token");
  }

  public getParsedJWTToken() {
    if (this.cookieService.get("app-token")) {
      let values = atob(this.cookieService.get("app-token").split('.')[1]);
      return JSON.parse(values);
    }
    else {
      return false;
    }
  }

  public isTokenValid() {
    if (this.cookieService.get("app-token")) {
      let values: any = atob(this.cookieService.get("app-token").split('.')[1]);
      return (new Date(JSON.parse(values).time * 1000) >= new Date());
    }
    return false;
  }

  public clearTokenCookie() {
    if (this.cookieService.get("app-token")) {
      this.cookieService.remove("app-token");
      this.router.navigate(['/Default']);
    }
  }
  public clearTokenCookieself() {
    if (this.cookieService.get("app-token")) {
      this.cookieService.remove("app-token");
    }
  }

}
